import { Endpoint } from "./BaseEndpoint";

export class ReCaptchaEndpoint extends Endpoint {
  constructor() {
    super("verify_recaptcha");
  }
}
